module.exports = __webpack_public_path__ + "img/filter_switch.6fb25f15.svg";